module.exports = __webpack_public_path__ + "static/media/angry.3348e416.png";